module.exports = __webpack_public_path__ + "img/gmlb_98.4492ac07.png";